require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center.json") })
        }
      }, "path---articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center!./.cache/json/articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center.json
// module id = 1555
// module chunks = 231608221292675